import React, { useState, useEffect } from 'react';
import {
  Grid,
  Box,
  Typography,
  useTheme,
  Dialog,
  DialogContent
} from '@material-ui/core';
import PageHeader from '../../../Components/PageHeader';
import LeftControl from '../../../Components/LeftControl';
import { useHistory, useLocation } from 'react-router-dom';

/** Local deoendencies & Libraries */
import Services from '../../../Services';
import { columnsForView, dashTableCol, dashTableColOther, testingEventColumns, testingEventColumnsDashboard } from '../../../Components/TableComponents/constants';
import DynamicTable from '../../../Components/TableComponents/DynamicTable';
import HardwareTable from '../../../Components/TableComponents/HardwareTable';
import { Button, Checkbox, Col, Form, Modal, Row } from 'antd';
import EmployeeEmergencyContact from '../../../Components/Modals/EmployeeEMergencyContact';
import { States } from '../../../helpers/state';
import { showSnackBar } from '../../../helpers/showSnackBar';
import { seriliazeParams } from '../../../helpers/seriliazeParams';
import { showText, ValidateDate } from '../../../helpers/textValidation';
import { errorMessage } from '../../../helpers';
import roleManager from '../../../Components/roles';
import { useSelector } from 'react-redux';
import PageLayout from '../../../Components/LayoutComponents/PageLayout';

var moment = require('moment-timezone')
const {
  employee,
  broadcast,
  Storage,
  hr
} = Services;

const Dashboard = () => {

  const storage = new Storage();
  const history = useHistory();
  const [rows, setRows] = useState([])
  const [modalData, setModalData] = useState([])
  const [open, setOpen] = useState(false);
  const [testEventRows, settestEventRows] = useState([])
  const [broadCastModalsData, setBroadCastModalsData] = useState([])
  const [visibleBCModals, setVisibleBCModals] = useState([])
  const [openContact, setOpenContact] = useState(false);
  const [emergencyContact, setEmergencyContact] = useState();
  const [flag, setFlag] = useState(false);
  const [userProfile, setuserProfile] = useState(null)
  const [rerender, setRerender] = useState(false)
  const [BMWatch, setBMWatch] = useState(null)


  const onClickEditEmergencyContact = () => {
    const token = localStorage.getItem("access_jwt")
    if (!token) {
      localStorage.clear()
      history.push('/login/140040')
      errorMessage()
      return
    }
    setOpenContact(true);
  };

  let emergencyModalData = {
    employeeDetails: { ...JSON.parse(localStorage.getItem('user_profile')) },
    emergencyContact: emergencyContact,
    open: openContact,
    close: setOpenContact,
    statesList: States,
    mainFlag: flag,
    setMainFlag: setFlag,
  };

  const getEmployeeDetails = async (forcedParams = {}) => {

    let user = JSON.parse(localStorage.getItem('user_profile'))

    try {
      const applicantDataHistory = await hr.getMyEmployee({
        ...(user || {}),
        ...forcedParams,
      });

      if (applicantDataHistory?.emergency_contact?.length)
        setEmergencyContact(applicantDataHistory?.emergency_contact[0]);
    }
    catch (exc) { }
  };


  const dastTableData = {
    header: dashTableCol,
    rows: rows?.map(row => [
      <></>,
      // row?.EmployeeId,
      row?.name,
      row?.issue_date,
      row?.expiry_date,
    ])
  }


  const handleClose = () => {
    setOpen(false);
  };

  const getlistEvents = async (offset = 0, limit = 10) => {
    let params = '?'.concat(seriliazeParams({ offset, limit }))
    try {
      let data = await employee.get_test_event_listing_dashboard({ params });

      if (data.httpStatus === 200) {
        data?.data?.event?.rows?.forEach(({ TestEvent }) => {
          TestEvent.date = ValidateDate(TestEvent?.date)
          TestEvent.time = TestEvent?.time?.slice(0, -3)
          TestEvent.evaluator = `${showText(TestEvent?.Employee?.firstName)} ${showText(TestEvent?.Employee?.lastName)}`
          TestEvent.rulesCount = `${showText(TestEvent?.TestEventRules?.length)}`
        });
        settestEventRows(data?.data?.event?.rows)
      }
    } catch (error) {

    }
  }

  const handleClickOpen = async (value) => {
    try {
      let data = await employee.view_rule_event_dashboard({ id: value })
      if (data?.httpStatus === 200) {
        data = data?.data?.map(row => {
          return {
            id: row.id,
            eventID: (row?.TestEventRule?.TestEventId) ? row.TestEventRule?.TestEventId : null,
            rule_NBR: (row?.TestEventRule?.Rule?.RuleNo) ? row.TestEventRule?.Rule.RuleNo : null,
            crew_member: (row?.Employee?.firstName) ? `${row?.Employee?.firstName} ${row?.Employee?.lastName}` : null,
            result: (row?.result) ? row?.result : null,
            comment: (row?.comment) ? row?.comment : null
          }
        })
        data.sort((a, b) => {
          return (b.id - a.id)
        })
        setModalData(data)
      }
    } catch (error) {

      return showSnackBar(`Please Try  Again \n Error Occured while fetching data: ${error}`);
    }
    let token = localStorage.getItem('access_jwt')
    if (!token) {
      localStorage.clear()
      history.push('/login/140040')
      errorMessage()
    }
    setOpen(true);
  };


  const testingEventData = {
    header: testingEventColumnsDashboard,
    rows: testEventRows?.slice(0, 5)?.map(({ TestEvent }) => [
      TestEvent?.id,
      TestEvent?.date,
      TestEvent?.time,
      TestEvent?.evaluator,
      TestEvent?.jobID,
      TestEvent?.rulesCount,
      <Button onClick={() => handleClickOpen(TestEvent?.id)} className="ViewIcon" style={{ color: "transparent" }}>.</Button>
    ])
  }

  const viewTableData = {
    header: columnsForView,
    rows: modalData.map(row => [
      row?.id,
      row?.eventID,
      row?.rule_NBR,
      row?.crew_member,
      row?.result,
      row?.comment
    ])
  }


  const handleCancel = (index) => {
    const newVisibleModals = [...visibleBCModals];
    newVisibleModals[index] = false;
    setVisibleBCModals(newVisibleModals);
    setBMWatch(null)
  };

  const handleOnFinish = async (values, id, i) => {
    let response = await broadcast?.acknowledgeAndClose({ id, is_read: values?.is_read || false })
    if (response?.httpStatus === 200) {
      handleCancel(i)
      setRerender(prev => prev = !prev)
      setBMWatch(null)
    }
  }

  const modalToShow = (x, i) => {
    let map = {
      1: <Modal
        open={visibleBCModals[i]}
        onCancel={() => handleCancel(i)}
        footer={false}
        header={false}
        centered
        mask={false}
      >
        <Form
          onFinish={(values) => handleOnFinish(values, x?.id, i)}
          onFinishFailed={err => console.log(err)}
          onValuesChange={(a, b) => setBMWatch(b)}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontSize: "12px", fontWeight: "600" }}>Subject</span>
              <span className="AlertPopTextBox AlertPopTextarea" style={{ margin: "0px" }}>
                {x?.BroadcastMessage?.subject}
              </span>
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontSize: "12px", fontWeight: "600" }}>Message</span>
              <span className="AlertPopTextBox AlertPopTextarea" style={{ margin: "0px" }}>
                Dear recipient,<br />
                {x?.BroadcastMessage?.message}
              </span>
            </div>

            <Form.Item
              name="is_read"
              valuePropName="checked"
            >
              <Checkbox>Check here to confirm you have read this message</Checkbox>
            </Form.Item>

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <button type='submit' style={{ width: "50%" }} className="LinkButton" disabled={!BMWatch?.is_read ? true : false}>
                Acknowledge & Close
              </button>
            </div>

          </div>
        </Form>
      </Modal>,

      3: <Modal
        open={visibleBCModals[i]}
        onCancel={() => handleCancel(i)}
        footer={false}
        header={false}
        centered
        mask={false}
      >
        <Form
          onFinish={async () => {
            let response = await broadcast?.acknowledgeAndClose({ id: x?.id, is_read: true })
            if (response?.httpStatus === 200) history?.push("/Locomotive-work-order-edit", { id: x?.WO_ID })
          }}
          onFinishFailed={err => console.log(err)}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontSize: "12px", fontWeight: "600" }}>Message</span>
              <span className="AlertPopTextBox AlertPopTextarea" style={{ margin: "0px" }}>
                {x?.message}
              </span>
            </div>

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <button type='submit' style={{ width: "50%" }} className="LinkButton">
                View Work Order
              </button>
            </div>

          </div>
        </Form>
      </Modal>,
    }
    return map[x?.type]
  }

  useEffect(async () => {

    roleManager(0, "sidebar", "dashboard")
    let isEmployee = JSON.parse(localStorage.getItem('isEmployee'))
    if (isEmployee) getEmployeeDetails()

    let user = JSON.parse(await storage.get('user_profile'))
    setuserProfile(user)
    if (user) {
      try {

        let data = await employee.get_employee_certificates({ id: user.id })
        if (data) {
          data.data.rows.forEach(row => {
            row.issue_date = moment(new Date(row.issue_date)).utc().format('MM-DD-YYYY')
            row.expiry_date = moment(new Date(row.expiry_date)).utc().format('MM-DD-YYYY')
          });
          setRows(data.data.rows)
        }
      } catch (error) {

      }
    }

    getlistEvents();

    //un-read broadcast messages
    ; (async () => {
      if (!history?.location?.state?.showBroadcastPopups) return
      let response = await broadcast.unRead()
      if (response?.httpStatus === 200) {
        setBroadCastModalsData(response?.data || []);
        setVisibleBCModals(response?.data?.map(() => true) || []);
      }
    })()


  }, [])



  return (
    <PageLayout>
      <Grid className="PagesFrame">
        <PageHeader rerender={rerender} />

        <Grid id="PageTitle">Dashboard</Grid>
        <Row className='mt20'>
          <Col md={19}>
            <p className='f20 bold '>
              TGS Software
            </p>
          </Col>
          <Col md={5}>
            <Grid onClick={onClickEditEmergencyContact} className="ProfilePicChangeBtn">
              <Button style={{ background: '#2963AD', color: 'white', border: 'none !important', borderRadius: '10px', height: '45px' }}> Update Emergency Contact</Button>
            </Grid>
            <EmployeeEmergencyContact EmergencyEditModal={emergencyModalData} />
          </Col>
        </Row>

        <Grid xs={12} className="">
          {/* TGS Softwares */}
          <Grid xs={12}>
            {/* <Typography variant="h6" component="h6">TGS Software</Typography> */}
            <Grid xs={12} container justify="space-between">
              <Grid className="DashSoftware DashBI">
                <a target="_blank" href="https://bi.tgsgroup.com/TGSBI_Prod/LogOn/"></a>
              </Grid>
              {/* <Grid className="DashSoftware DashSaleforce">
                  <a target="_blank" href="https://login.salesforce.com/"></a>
                </Grid> */}
              <Grid className="DashSoftware DashAssetPro">
                <a target="_blank" href="https://railroadsoftware.io/tgs/simplesaml/www/module.php/saml/sp/metadata.php/default-sp?output=xhtml"></a>
              </Grid>
              {/* <Grid className="DashSoftware DashSafeTrack">
                  <a target="_blank" href="https://xtgs1.maxaccel.com/SafeTrack/"></a>
                </Grid> */}
              <Grid className="DashSoftware Cedar">
                <a target="_blank" href="https://arms.cedarai.com"></a>
              </Grid>
              {/* <Grid className="DashSoftware DashLocstatt">
                  <a target="_blank" href="https://locstatt.net/login.html"></a>
                </Grid> */}
            </Grid>
          </Grid>

          <div style={{ display: "grid", gridTemplateColumns: "50% 50%", justifyContent: "space-between", gap: "10px" }}>

            <Grid xs={12} className=" mt60">
              <p className="f20 bold ">Certifications & Licenses</p>
              <Grid
                xs={12}
                container
                justify="space-between"
                className="LiqTables Dash-Table DashTable-Desk"
              >
                <DynamicTable tableData={dastTableData} />
              </Grid>

            </Grid>
            <Grid xs={12} className=" mt60 ">
              <p className="f20 bold ">Assigned Hardware</p>
              <Grid
                xs={12}
                container
                justify="space-between"
                className="DashTable-Desk"
              >
                <HardwareTable disabled={true} employee={JSON.parse(localStorage.getItem('user_profile'))} page={"dashboard"} />
              </Grid>
            </Grid>
          </div>
          {[18, 19, 2].includes(userProfile?.SubDepartmentId) ? <>
            <p className="f20 bold " style={{ marginTop: "20px" }}>Recent Safety Testing Event</p>
            <DynamicTable tableData={testingEventData} Pagination={false} />
          </> : <></>}
        </Grid>
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        className="SafetyModal LiqTables"
        aria-labelledby="responsive-dialog-title"
      >
        <Button autoFocus onClick={handleClose} className="ModalClose">
        </Button>
        <DialogContent>
          <div className="p30">
            <DynamicTable tableData={viewTableData} />
          </div>
        </DialogContent>
      </Dialog>
      <div className="dashboard-custom-main-class">
        {
          broadCastModalsData?.length
            ? broadCastModalsData?.map((x, i) => modalToShow(x, i))
            : <></>
        }
      </div>
    </PageLayout >
  );
}
export default Dashboard;
